import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import FormInput from 'components/atoms/FormInput'
import Toggle from '../../components/atoms/Toggle'
import NotificationBell from '../../assets/svg/notification.svg'
import Dropdown from '../../components/atoms/Dropdown/index'
import { logoutHandler, setAuthRes, setUserLoggedIn } from 'redux/auth/auth.action'
import { getValues, removeValues, setValues } from '../../services/storage'
import { useNavigate } from 'react-router-dom'
import arrowDownIcon from '../../assets/svg/arrow-down.svg'
import arrowUpIcon from '../../assets/svg/arrow-up.svg'
import searchIcon from '../../assets/svg/search-icon.svg'
import NavDropdownData from '../../components/molecules/NavDropdownData'
import Button from 'components/atoms/Button'
import addSquare from '../../assets/svg/add-square.svg'
import { toggleModal } from 'redux/app/app.action'
import AppModal from './CustomModal'
import InviteBusiness from 'pages/dashboard/ModalComponents/InviteBusiness'
import ViewFees from 'pages/dashboard/ModalComponents/ViewFees'
import EditFees from 'pages/dashboard/ModalComponents/EditFees'


const TopNav = ({ toggleModal, modal_state, setAuthRes, setUserLoggedIn, auth_data, userData, logoutHandler, bearerToken }) => {
  const [value, setValue] = useState("")
  const [showModal, setShowModal] = useState(false)
  const [dropdown, setDropdown] = useState(false)

  const { dropdownData, modalId, modalState, setModalState } = NavDropdownData(logoutHandler, bearerToken)

  const userName = getValues('username');

  const fname = userData?.first_name;
  const lname = userData?.last_name;
  const username = fname + ' ' + lname;

  const handleOnChange = e => {
    setValue(e.target.value)
  }

  const showDropdown = () => {
    setDropdown(prevState => !prevState)
  }

  // const username = getValues('username')

  return (
    <>
      <div className={`flex justify-end p-3 px-8 shadow-lg h-full`}>
        {/* <div className='desktop:w-5/12'>
          <FormInput
            type="search"
            name="searchItem"
            placeholder="Search payment references, transactions, clients"
            style='text-Black2 !bg-white'
            inputStyle="!bg-GrayCustom6 text-Black2"
            inputStyle2={`text-xs leading-5 text-GrayCustom7 pl-8`}
            value={value}
            img={searchIcon}
            imgStyle="w-4 h-4 !relative !left-5"
            validationErr=""
            onClick={() => { }}
            onChange={handleOnChange}
          />
        </div> */}
        <div className='flex justify-between items-center gap-5 w-fit'>
          <Button
            btnType='button'
            btnText='Invite Business'
            btnImg={addSquare}
            btnImgStyle='w-4 h-4'
            btnStyle='bg-DarkBg3 text-white gap-3 py-2 px-3 flex-row-reverse font-normal text-[15px] w-fit whitespace-nowrap flex-shrink-0'
            onClick={() => {
              setShowModal(prevState => !prevState)
            }}
          />

          {/* <div className='relative flex justify-between flex-shrink-0 cursor-pointer'>
            <span className='flex-shrink-0'>
              <img src={NotificationBell} alt="notification_bell" className='w-7 h-7' />
            </span>
            <span className='absolute top-1 right-0 w-[14px] h-[14px] rounded-full bg-PrimaryActive flex justify-center items-center text-white text-xs font-normal'>
              5
            </span>
          </div> */}

          <Dropdown
            dropdown={dropdown}
            setDropdown={setDropdown}
            dropdownData={dropdownData}
            dropdownStyle="right-0 top-12 animate-slide_down !gap-3"
          >
            <div className='flex items-center gap-2 cursor-pointer'>
              <div className='flex flex-shrink-0 justify-center items-center bg-DarkBg3 rounded-full w-7 h-7 p-5'>
                <span className='flex-shrink-0 font-bold text-[12px] leading-4 text-center mx-auto text-SecondaryAccent4'>
                  {/* {userName?.slice(0, 2).toUpperCase()} */}
                  {username
                    .split(' ')
                    .map((word) => word.slice(0, 1))
                    .join()
                    .replaceAll(',', '')
                    .toUpperCase()}
                </span>
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
      {showModal &&
        <InviteBusiness
          showModal={showModal}
          setShowModal={setShowModal}
        />
      }
      {modalState && modalId === 'view_fees'
        ? <ViewFees setModalState={setModalState} />
        : modalState && modalId === 'edit_fees'
          ? <EditFees setModalState={setModalState} />
          : null
      }
    </>
  )
}

const mapStateToProps = (state: any) => ({
  auth_data: state.auth.auth_data,
  userData: state.auth?.user_authData,
  bearerToken: state.auth.user_authData?.token,
  modal_state: state.app.modal_state
})

const mapDispatchToProps = (dispatch: any) => ({
  toggleModal: (data: boolean) => dispatch(toggleModal(data)),
  logoutHandler: () => dispatch(logoutHandler()),
  setAuthRes: (data: any) => dispatch(setAuthRes(data)),
  setUserLoggedIn: (data: any) => dispatch(setUserLoggedIn(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(TopNav)